<template>
	<div>
		<label>{{labelText}}</label>
		<div class="d-flex">
			<div
				class="mr-3 mask"
				@click="activateFn"
			>
				<input-text
					:class="[
					'input-button',
					activate ? 'active-input' : null
					]"
					disabled
					v-bind="$attrs"
					v-model="val"
				/>
			</div>
			<input-text
				v-if="activate"
				:readonly="blockButton"
				:value="value"
				@input="sendValue"
			/>
		</div>
	</div>
</template>
<script>
import inputText from '@/clerkinn/shared/input-text';

function mounted() {
	this.val = `$${this.value}`;
}

function sendValue(value) {
	this.$emit('input', value);
}

function activateFn() {
	if (!this.blockButton) {
		this.activate = !this.activate;
		this.$emit('activate-button', this.activate);
	}
}

function activatedButton(newValue) {
	this.activate = newValue;
}

function updateValue(newValue) {
	this.val = `$${newValue}`;
}

function data() {
	return {
		activate: false,
		val: null,
	};
}

export default {
	name: 'button-field',
	components: {
		inputText,
	},
	inheritAttrs: false,
	data,
	methods: {
		activateFn,
		sendValue,
		updateValue,
	},
	mounted,
	props: {
		activatedButton: {
			default: false,
			type: Boolean,
		},
		blockButton: {
			default: false,
			type: Boolean,
		},
		labelText: {
			default: '',
			type: String,
		},
		value: null,
	},
	watch: {
		activatedButton,
		value: updateValue,
	},
};
</script>





// WEBPACK FOOTER //
// ButtonField.vue?1122ba80